import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";

import ClientFollowUp from "../../_shark_models/ClientFollowUp";

import templateContent from "./followup-modal.html";
import showFollowUpListButton from "./show-follow-up-list-button.html";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class FollowUpComponent extends Component {
	constructor () {
		super("followUpComponent");

		this.addTemplate("", templateContent);
		this.addTemplate("showFollowUpListButton", showFollowUpListButton);
	}

	beforeLoad () {
		const targetItem = this.get("targetItem");

		if (targetItem && targetItem.guid !== "") {
			switch (targetItem.__modelName) {
				case "Client":
				case "ClientVisit":
				case "Prospect":
				case "Visit":
					followUpManager.getListForItem(targetItem)
					.then(() => Shark.render());
					break;
			}
		}
		else if (Shark.activePage.id === "visitEditView" && targetItem.guid === "" && targetItem.clientGuid !== "") {
			followUpManager.getListForClient(targetItem.clientGuid);
		}

		if (Shark.activePage.id === "clientEditView" || Shark.activePage.id === "prospectEditView") {
			Shark.set({ currFollowUp: null });
		}

		this.set({
			__importantFUDisabled: ["constructionSiteListView"].includes(Shark.activePage.id) ? "disabled" : "",
			__showImportantFUOptions: ["constructionSiteCardListView", "constructionSiteListView", "leadListView", "quotationListView"].includes(Shark.activePage.id),
		});
	}

	deleteFollowUpBtn_clickHandler (event, data) {
		if (confirm("Sei sicuro di voler eliminare questo Follow Up?\nNon sarà possibile annullare!")) {
			const targetItem = this.get("targetItem");
			const currFollowUp = Utils.safp(targetItem.__followUpList, "guid", data.guid);

			followUpManager.delete(currFollowUp)
			.then(deleteResponse => {
				console.log({deleteResponse});
				if (deleteResponse.data.itemCount === 1) {
					document.querySelector(`[data-guid="${data.guid}"]`).closest(".singleFollowUpRow").remove();
					targetItem.__followUpList = targetItem.__followUpList.filter(item => item.guid !== data.guid);
				}
			});
		}
	}

	editFollowUpBtn_clickHandler (event, data) {
		const targetItem = this.get("targetItem");
		const currFollowUp = Utils.safp(targetItem.__followUpList, "guid", data.guid);
	
		//Dave.Warn: Anche qui sotto sarebbe meglio mettere a true solo quello corrispondente alla pagina attiva
		Shark.set({
			currFollowUp
		});
		
		$("#followUpListModal").modal("show");
		this.set({open: true});
	
		const addFollowUpForm = document.querySelector("#addFollowUpForm");
	
		if (addFollowUpForm) {
			addFollowUpForm.classList.add("show");
		}
	}
	
	followUpListModalCloseBtn_clickHandler () {
		$("#followUpListModal").modal("hide");
		this.set({open: false});
	}

	init () {
		const followUpFilters = Shark.getInstance("__smart__", {
			type: "all"
		});
	
		followUpFilters.onDataChanged = function (data) {
			const requestedType = data.newValue;
			console.log({data});
	
			if (requestedType !== "all") {
				document.querySelectorAll(".singleFollowUpRow").forEach(item => {
					if (item.dataset.type === requestedType) {
						item.classList.remove("d-none");
					}
					else {
						item.classList.add("d-none");
					}
				});
			}
			else {
				document.querySelectorAll(".singleFollowUpRow").forEach(item => {
					item.classList.remove("d-none");
				});
			}
		};
	
		Shark.set({
			currFollowUp: null,
			followUpFilters,
			userList: Shark.get("userList") || [],
		});
	
		if (Shark.get("userList").length === 0) {
			userManager.getList();
		}
		this.set({
			open: false,
			sourceList: [],
			targetItem: null
		});
	}

	prepareNewFollowUp (targetItem) {
		let clientGuid = "";
		let clientName = "";
		let referenceType = targetItem.__modelName.substr(0, 1).toLowerCase() + targetItem.__modelName.substr(1);
		referenceType = referenceType === "visit" ? "clientVisit" : referenceType;

		switch (referenceType) {
			case "client":
				clientGuid = targetItem.guid;
				break;
			case "clientVisit":
			case "constructionSite":
			case "constructionSiteCard":
			case "notComplianceReport":
			case "quotation":
			case "siteInfoSheet":
				clientGuid = targetItem.clientGuid;
				break;
			case "sampleRequest":
				clientGuid = targetItem.contactGuid;
				break;
		}

		switch (referenceType) {
			case "client":
				clientName = targetItem.name;
				break;
			case "clientVisit":
				clientName = targetItem.prospectName || targetItem.contactName;
				break;
			case "constructionSite":
			case "constructionSiteCard":
			case "siteInfoSheet":
				clientName = targetItem.registry.clientName;
				break;
			case "notComplianceReport":
				clientName = targetItem.clientName;
				break;
			case "quotation":
				clientName = targetItem.siteInfoSheetData.clientName;
				break;
			case "sampleRequest":
				clientName = targetItem.contactName;
				break;
			// case "siteInfoSheet":
			// clientName = targetItem.registry.clientName;
			// break;
		}

		const currFollowUp = new ClientFollowUp({
			body: "",
			clientGuid,
			["extraData.important"]: ["constructionSiteListView"].indexOf(Shark.activePage.id) > -1,
			referenceGuid: targetItem.guid,
			referenceType: referenceType,
			status: 1,
			type: "note"
		});

		currFollowUp.extraData.important = ["constructionSiteListView"].indexOf(Shark.activePage.id) > -1;

		return {clientName, currFollowUp};
	}

	showFolloUpList (event, data) {
		const targetItem = this.get("targetItem");
		// console.log({targetItem});
	
		if (Shark.activePage.id === "clientEditView" || Shark.activePage.id === "prospectEditView" || Shark.activePage.id === "visitEditView") {
			// Fake code to avoid errors
		}
		else {
			// DAve: Ho la vaga sensazione che questa roba sovrascriva quella sotto... 
			if (targetItem) {
				const newFollowUpData = this.prepareNewFollowUp(targetItem);
	
				Shark.set({
					currFollowUp: newFollowUpData.currFollowUp
				});
			}
		}
		waitBoxComponent.hide();
		if (targetItem && data !== "isSystem") {
			Shark.render();
			$("#followUpListModal").modal("show");
			this.set({open: true});
	
			//Dave.ToDo: Qui dovrebbe esserci un controllo solo su quelli da confermare, dovrei farmi dare l'informazione riguardo il "letto" quando ottengo la lista.
			if (targetItem.__followUpList && targetItem.__followUpList.length > 0 && data !== "fromSave") {
				followUpManager.setAsViewed(targetItem.__followUpList)
				.then(() => {
					targetItem.newFollowUpCount = 0;
					targetItem.__hasNewFollowUp = false;
	
					document.querySelectorAll(`.showFollowUpList[data-guid="${targetItem.guid}"]`).forEach(item => item.classList.remove("has-new-followup", "has-new-followup2"));
					document.querySelectorAll(`.showFollowUpList[data-guid="${targetItem.guid}"] > .badge-danger`).forEach(item => item.classList.add("d-none"));
					document.querySelectorAll(`.showFollowUpList[data-client-guid="${targetItem.clientGuid}"]`).forEach(item => item.classList.remove("has-new-followup", "has-new-followup2"));
					document.querySelectorAll(`.showFollowUpList[data-client-guid="${targetItem.clientGuid}"] > .badge-danger`).forEach(item => item.classList.add("d-none"));


					// //Dave: Questo è da togliere quando avrò finito.
					// const targetItemFollowUpBtn = document.querySelector(`.showFollowUpList[data-guid="${targetItem.guid}"]`);
					// if (targetItemFollowUpBtn) {
					// 	targetItemFollowUpBtn.classList.remove("has-new-followup");
					// }
					


					// const targetItemFollowUpBtnList = document.querySelectorAll(`.showFollowUpList[data-client-guid="${targetItem.clientGuid}"]`);
	
					// if (targetItemFollowUpBtnList.length > 0) {
					// 	targetItemFollowUpBtnList.forEach(item => item.classList.remove("has-new-followup"));
					// }
				});
			}
		}
	}

	showFollowUpList_clickHandler (event, data) {
		let sourceList = this.get("sourceList");

		console.log({data, sourceList});
		// : data.notComplianceReportList,

		if (!sourceList || sourceList.length === 0) {
			if (Shark.activePage.id === "homeView") {
				switch (data.type) {
					case "constructionSite":
						sourceList = Shark.get("latestConstructionSiteList");
						break;
					case "constructionSiteCard":
						sourceList = Shark.get("latestConstructionSiteCardList");
						break;
					case "notComplianceReport":
						sourceList = Shark.get("latestNotComplianceReportList");
						break;
					case "quotation":
						sourceList = Shark.get("latestQuotationList");
						break;
					case "siteInfoSheet":
						sourceList = Shark.get("latestSiteInfoSheetList");
						break;
					case "visit":
						sourceList = Shark.get("latestVisitList");
						break;
				}
			}
			else {
				switch (data.type) {
					case "constructionSite":
						sourceList = Shark.get("constructionSiteList");
						break;
					case "constructionSiteCard":
						sourceList = Shark.get("constructionSiteCardList");
						break;
					case "notComplianceReport":
						sourceList = Shark.get("notComplianceReportList");
						break;
					case "quotation":
						sourceList = Shark.get("quotationList");
						break;
					case "sampleRequest":
						sourceList = Shark.get("sampleRequestList");
						break;
					case "siteInfoSheet":
						sourceList = Shark.get("siteInfoSheetList");
						break;
					case "visit":
						sourceList = Shark.get("visitList");
						break;
				}
			}
		}

		console.log({data, sourceList});

		if (sourceList.length > 0) {
			const targetItem = Utils.safp(sourceList, "guid", data.guid);
			const newFollowUpData = this.prepareNewFollowUp(targetItem);

			const followUpTypeList = Shark.get("followUpTypeList");
			if (newFollowUpData.currFollowUp.referenceType !== "constructionSiteCard") {
				followUpTypeList.forEach(item => item.enabled = item.id !== "constructionSiteProblem");
			}
			else {
				followUpTypeList.forEach(item => item.enabled = true);
			}

			Shark.set({currFollowUp: newFollowUpData.currFollowUp});
			waitBoxComponent.show();//Dave: schifo, ma al set si renderizza e sparisce. Devo fare in modo che il waitbox sappia di esserci.
			this.set({
				clientName: newFollowUpData.clientName,
				targetItem,
			});
			followUpManager.getListForItem(targetItem)
			.then(() => {
				followUpComponent.showFolloUpList();
			});
			console.log({currFollowUp: newFollowUpData.currFollowUp, targetItem});
		}
		else {
			alert("Attenzione, si è verificato un errore, per favore segnalare l'errore FU-C-313");
			return;
		}
	}

	showFollowUpImportantReceiversBtn_clickHandler (event, data) {
		const targetItem = this.get("targetItem");
		const currFollowUp = Utils.safp(targetItem.__followUpList, "guid", data.guid);

		if (currFollowUp && currFollowUp.extraData.reminder.ts) {
			alert(`Questo Follow Up è stato segnalato come importante a:\n${currFollowUp.extraData.importantNotificationReceiver.map(item => item.firstName + " " + item.lastName + "\n").join("")}`);
		}
	}

	showFollowUpReminderBtn_clickHandler (event, data) {
		const targetItem = this.get("targetItem");
		const currFollowUp = Utils.safp(targetItem.__followUpList, "guid", data.guid);

		if (currFollowUp && currFollowUp.extraData.reminder.ts) {
			alert("Attività: " + currFollowUp.__reminderTypeLabel + "\nData: " + currFollowUp.__reminderDateLabel);
		}
	}



	
	addFollowUpBtn_clickHandler () {
		const targetItem = this.get("targetItem");

		let referenceType = targetItem.__modelName.substr(0, 1).toLowerCase() + targetItem.__modelName.substr(1);
		referenceType = referenceType === "visit" ? "clientVisit" : referenceType;

		const currFollowUp = Shark.getInstance("ClientFollowUp", {
			body: "",
			clientGuid: targetItem ? (targetItem.clientGuid ? targetItem.clientGuid : targetItem.guid) : "",
			referenceGuid: targetItem ? targetItem.guid : "",
			referenceType: referenceType,
			status: 1,
			type: "note"
		});

		//Dave.Warn: Anche qui sotto sarebbe meglio mettere a true solo quello corrispondente alla pagina attiva
		Shark.set({
			currFollowUp,
		});
	}

	saveNewFollowUpBtn_clickHandler () {
		const [currFollowUp, currUser, userList] = Shark.get(["currFollowUp", "currUser", "userList"]);
		const targetItem = this.get("targetItem");
		let agent;
		const fuActionDone = currFollowUp.guid === "" ? "inserito" : "<strong>modificato</strong>";

		// Dave.Info: Se è una modifica non devo riaggiungere i destinatari, sono già salvati.
		if (currFollowUp.extraData.important && currFollowUp.guid === "") {
			//Dave: Ma perché faccio questo sulla page e non sul type del FU???????
			switch (Shark.activePage.id) {
				case "constructionSiteListView":
					agent = Utils.safp(userList, "guid", targetItem.userGuid);

					currFollowUp.extraData.importantNotificationReceiver.push({
						eMail: agent.email,
						firstName: agent.firstName,
						lastName: agent.lastName,
						userGuid: agent.guid,
					});

					break;
				case "leadListView": {
					const agents = targetItem.referenceAgentsGuids.map(item => Utils.safp(userList, "guid", item));

					currFollowUp.extraData.importantNotificationReceiver.push(...agents.filter(item => item != null).map(item => {
						return {
							eMail: item.email,
							firstName: item.firstName,
							lastName: item.lastName,
							userGuid: item.guid,
						};
					}));

					break;
				}
				case "quotationListView": {
					agent = Utils.safp(userList, "guid", targetItem.userGuid);

					currFollowUp.extraData.importantNotificationReceiver.push({
						eMail: agent.email,
						firstName: agent.firstName,
						lastName: agent.lastName,
						userGuid: agent.guid,
					});

					let areaManager;
		
					if (agent.preferences.areaManagerGuid && agent.preferences.areaManagerGuid !== "") {
						areaManager = Utils.safp(userList, "guid", agent.preferences.areaManagerGuid);
						
						if (areaManager) {
							currFollowUp.extraData.importantNotificationReceiver.push({
								eMail: areaManager.email,
								firstName: areaManager.firstName,
								lastName: areaManager.lastName,
								userGuid: areaManager.guid,
							});
						}
					}
					break;
				}
			}
		}

		followUpManager.save(currFollowUp)
		.then(saveFUResponse => {
			console.log({saveFUResponse});
			if (currFollowUp.extraData.important) {
				let clientName = "";
				let messageBody = "";
				let quotationCode = "";
				let quotationDate = "";

				switch (currFollowUp.referenceType) {
					case "constructionSite":
						messageBody = `BuonGiorno [[item.firstName]],
							
							questa eMail per comunicare che ${currUser.__fullName} ha ${fuActionDone} un follow-up relativo al Cantiere <strong>${targetItem.__siteLocationLabel}</strong> (con partenza in data ${targetItem.__startDateLabel}) per <strong>${targetItem.registry.clientName}</strong> segnalandolo come importante.
							
							Di seguito il contenuto della segnalazione:
							<strong><q>${currFollowUp.body}</q></strong>

							Buona Giornata,
							IPM HUB

							<small>Questa eMail è stata generata in automatico, ma è possibile rispondere per contattare direttamente ${currUser.__fullName}.
						`;
						break;
					case "client":
						messageBody = `BuonGiorno [[item.firstName]],
							
							questa eMail per comunicare che ${currUser.__fullName} ha ${fuActionDone} un follow-up relativo al Lead <strong>${targetItem.name}</strong> segnalandolo come importante.
							
							Di seguito il contenuto della segnalazione:
							<strong><q>${currFollowUp.body}</q></strong>

							Buona Giornata,
							IPM HUB

							<small>Questa eMail è stata generata in automatico, ma è possibile rispondere per contattare direttamente ${currUser.__fullName}.
						`;
						break;
					case "quotation":
						clientName = targetItem.siteInfoSheetData.clientName;
						quotationCode = targetItem.code;
						quotationDate = targetItem.__referenceDateLabel;

						messageBody = `BuonGiorno [[item.firstName]],
							
							questa eMail per comunicare che ${currUser.__fullName} ha ${fuActionDone} un follow-up relativo al Preventivo <strong>${quotationCode}</strong> (del ${quotationDate}) per <strong>${clientName}</strong> segnalandolo come importante.
							
							Di seguito il contenuto della segnalazione:
							<strong><q>${currFollowUp.body}</q></strong>

							Buona Giornata,
							IPM HUB

							<small>Questa eMail è stata generata in automatico, ma è possibile rispondere per contattare direttamente ${currUser.__fullName}.
						`;
						break;
				}

				const messageList = currFollowUp.extraData.importantNotificationReceiver.map(item => {
					const body = messageBody.replace("[[item.firstName]]", item.firstName);

					return Shark.getInstance("__smart__", {
						body,
						senderEMail: currUser.email,
						senderName: currUser.__fullName,
						subject: "IPM HUB | Inserito un follow-up importante",
						receiverEMail: item.eMail,
						receiverName: item.firstName + " " + item.lastName,
					});
				});

				if (messageList.length > 0) {
					userManager.sendMessages(messageList)
					.then(sendMessagesResponse => {
						console.log(sendMessagesResponse);
					});
				}
			}

			if (this.get("open")) {
				followUpComponent.showFolloUpList();
			}
			else {
				if (Shark.activePage.id === "clientEditView" || Shark.activePage.id === "prospectEditView" || Shark.activePage.id === "visitEditView") {
					Shark.set({
						currFollowUp: null,
					});
				}
				
				waitBoxComponent.hide();
			}
		});
	}
}

const followUpComponent = new FollowUpComponent();

Shark.registerComponent(followUpComponent);

export default followUpComponent;
